import { render, staticRenderFns } from "./TerminalVirtualAccounts.vue?vue&type=template&id=4cc9f946"
import script from "./TerminalVirtualAccounts.vue?vue&type=script&lang=js"
export * from "./TerminalVirtualAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports